import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { showcaseIndicators } from '../../data/salesContent';
export function ProductShowcaseSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" style={{
    backgroundImage: 'radial-gradient(ellipse 50% 40% at 50% 45%, rgba(212,175,55,0.08), transparent 70%)'
  }} data-id="element-166" data-mp="68hyt3eadu3j">
      <div className="mx-auto max-w-6xl" data-id="element-167" data-mp="y07l5cqox2cn">
        <SectionHeading title="Esto es todo lo que recibís" data-id="element-168" data-mp="xz5yeb0barf3" />
        <ul className="mx-auto mt-12 flex max-w-4xl flex-wrap justify-center gap-3" data-id="element-169" data-mp="tz426hdciq77">
          {showcaseIndicators.map(({
          label,
          icon: Icon
        }) => <li key={label} className="flex items-center gap-2 rounded-full border border-gold/30 bg-ink-soft px-4 py-2.5" data-id="element-170" data-mp="p617g5wu1apf">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-171" data-mp="1ho6k7qbw6l28" />
              <span className="text-base font-semibold text-cream" data-id="element-172" data-mp="1hqjb4szmo5rf">{label}</span>
            </li>)}
        </ul>
        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-173" data-mp="1cvvlgqsw15b9">
          <p className="text-xl text-neutral-400 md:text-2xl" data-id="element-174" data-mp="2ze6brr9jk8g9">No estás comprando simplemente ebooks.</p>
          <p className="mt-4 font-display text-2xl font-black uppercase leading-tight text-cream md:text-4xl" data-id="element-175" data-mp="34bga5wewrug8">
            Estás accediendo a un <span className="text-gold" data-id="element-176" data-mp="2qiqlfk7zwbff">sistema de trabajo</span> para tus capacitaciones.
          </p>
        </div>
        <div className="mt-10" data-id="element-177" data-mp="2gmnb3r2zp6he">
          <CtaButton data-id="element-178" data-mp="2glc5dlpzhonn">Quiero acceder al sistema</CtaButton>
        </div>
      </div>
    </section>;
}